import classNames from "classnames";
import lodash from "lodash";
import React, { useCallback, useLayoutEffect, useRef, useState } from "react";
import { SPOILER_TYPE } from "./../../ricos-content/index.js";
import { buildThemeCssVars, THEME_DEFAULTS } from "./../../ricos-styles/index.js";
import {
  AccessibilityListener,
  getLangDir,
  GlobalContext
} from "./../../wix-rich-content-common/index.js";
import viewerStyles from "../statics/rich-content-viewer-scss.js";
import rtlStyles from "../statics/rtl-scss.js";
import AddAnchors from "./components/AddAnchors.js";
import ContentTraverser from "./ContentTraverser.js";
const styles = { ...viewerStyles, ...rtlStyles };
const ContentViewer = (props) => {
  const {
    config = {},
    onHover,
    isMobile = false,
    addAnchors,
    onMouseOver = () => {
    },
    content,
    setRef,
    typeMappers,
    nodeViewRenderers,
    nodeViewDecorators,
    experiments = {},
    t
  } = props;
  const [minHeight, setMinHeight] = useState(void 0);
  const viewerRef = useRef(null);
  const contentRef = useRef(null);
  useLayoutEffect(() => {
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    if (!isSafari || !contentRef.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      const newHeight = entries[0].contentRect.height;
      if (newHeight > 0) {
        setMinHeight(newHeight);
      }
    });
    resizeObserver.observe(contentRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [content]);
  const handleRef = useCallback(
    (node) => {
      viewerRef.current = node;
      if (setRef) {
        setRef.current = node;
      }
    },
    [setRef]
  );
  const SpoilerViewerWrapper = config[SPOILER_TYPE]?.SpoilerViewerWrapper;
  const contextualData = getContextualData(props);
  const viewerClassName = classNames(styles.viewer, {
    [rtlStyles.rtl]: contextualData.textDirection === "rtl"
  });
  const themeWithDefaults = lodash.merge(
    {},
    isMobile ? THEME_DEFAULTS.mobile : THEME_DEFAULTS.desktop,
    contextualData.theme
  );
  const style = buildThemeCssVars(themeWithDefaults, content?.documentStyle ?? {});
  const dataId = { "data-id": "content-viewer" };
  return /* @__PURE__ */ React.createElement(GlobalContext.Provider, { key: "RicosViewer", value: { experiments, isMobile, t } }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classNames(styles.wrapper),
      dir: contextualData.languageDir,
      style: {
        ...style,
        minHeight: minHeight ? `${minHeight}px` : void 0
      },
      onMouseEnter: (e) => onHover && onHover(e),
      onMouseOver,
      ref: handleRef,
      ...dataId
    },
    props.devTools,
    /* @__PURE__ */ React.createElement("div", { className: viewerClassName, ref: contentRef }, /* @__PURE__ */ React.createElement(AddAnchors, { addAnchors }, /* @__PURE__ */ React.createElement(
      ContentTraverser,
      {
        content,
        typeMappers,
        context: contextualData,
        nodeViewRenderers,
        nodeViewDecorators,
        SpoilerViewerWrapper
      }
    ))),
    /* @__PURE__ */ React.createElement(AccessibilityListener, { isMobile })
  ));
};
const getContextualData = ({
  t,
  theme,
  isMobile = false,
  anchorTarget,
  relValue,
  customAnchorScroll,
  config,
  locale,
  disabled,
  seoMode,
  iframeSandboxDomain,
  textAlignment,
  experiments,
  textDirection,
  direction,
  helpers,
  onNodeClick,
  jsdomMode,
  baseUrl
}) => {
  return {
    t,
    theme: theme || {},
    isMobile,
    anchorTarget,
    relValue,
    customAnchorScroll,
    config,
    helpers: helpers || {},
    locale: locale || "en",
    disabled,
    seoMode,
    iframeSandboxDomain,
    disableRightClick: config?.uiSettings?.disableRightClick,
    textAlignment,
    experiments,
    textDirection,
    languageDir: direction || getLangDir(locale),
    onNodeClick,
    jsdomMode,
    baseUrl
  };
};
var ContentViewer_default = ContentViewer;
export {
  ContentViewer_default as default
};
//# sourceMappingURL=ContentViewer.js.map
